import React from "react";
import "../styles/css/Contact.css";

export default function Contact() {
  const [emailContent, setEmailContent] = React.useState("Bonjour,\n");

  const handleEmailContentChange = (e) => {
    const value = e.target.value;

    setEmailContent(value);
  };

  return (
    <section id="contact" className="section">
      <div className="container">
        <div style={{ paddingBottom: 16 }}>
          <h2 className="title is-2">Contactez-nous</h2>
          <p>Pour toute question ou information supplémentaire, contactez-nous à l'adresse suivante:</p>
          <a className="button is-small is-primary is-light" href="mailto:yakoi.contact@gmail.com">
            <span className="icon is">
              <i className="fas fa-envelope"></i>
            </span>
            <span>yakoi.contact@gmail.com</span>
          </a>
        </div>
        {/* <form onSubmit={(e) => e.preventDefault()}>
          <div className="columns">
            <div className="column">
              <div className="field">
                <label htmlFor="" className="label">
                  Nom et prénom
                </label>
                <p class="control has-icons-left has-icons-right">
                  <input
                    class="input"
                    type="text"
                    placeholder="Jean Pierre Pernaud"
                  />
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                </p>
              </div>
            </div>
            <div className="column">
              <div className="field">
                <label htmlFor="" className="label">
                  Adresse mail
                </label>

                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="email" placeholder="Email" />
                  <span class="icon is-small is-left">
                    <i class="fas fa-envelope"></i>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="field">
            <label htmlFor="email-content" className="label">
              Message
            </label>
            <textarea
              className="textarea"
              placeholder="Votre méssage"
              rows="10"
              value={emailContent}
              onChange={handleEmailContentChange}
            />
          </div>
          <div class="control">
            <button class="button is-primary">
              <span className="icon">
                <i class="fas fa-paper-plane"></i>
              </span>
              <span>Envoyer</span>
            </button>
          </div>
        </form> */}
      </div>
    </section>
  );
}
